<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12 checkbox-row">
    <p-checkbox
      binary="true"
      [id]="control.key"
      [formControlName]="control.key"
      [disabled]="control.disabled"
      [(ngModel)]="checkBoxvalue"
      (ngModelChange) ="onStatusChange($event)"
    ></p-checkbox>
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
</div>
